import React from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';

interface SearchProps {
    id: string;
    name: string;
    onClick(id: string, name: string): void;
}


const SearchResults: React.FC<SearchProps> = (props) => {

    const classes = useStyles({});
    return (
        <div key={`user-${props.id}`} className={classes.container} onClick={() => props.onClick(props.id, props.name)}>
            <div>
                <div className={classes.name}>{props.name}</div>
                <div className={classes.id}>{props.id}</div>
            </div>
            <AddIcon />
        </div>
    );
}
export default SearchResults;

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: 5,
        '&:hover': {
            backgroundColor: '#F4F7FC'
        },
        cursor: 'pointer'
    },
    name: {
        fontSize: 14,
        color: '#5D759D'
    },
    id: {
        fontSize: 10
    }
}));



// WEBPACK FOOTER //
// ./src/components/inputs/SearchResultItem.tsx